import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import user from './modules/user/index.js';//用户信息
import department from './modules/department/index.js';//部门
import setting from './modules/setting/index.js';//设置
import personal from './modules/personal/index.js';//个人空间
import xiaoben from './modules/xiaoben/index.js';//教学资源
import analysis from './modules/analysis/index.js';//学情分析
import teaching from './modules/teaching/index.js';//学情分析
import batchDownload from './modules/batchDownload/index.js'; // 批量下载
const debug = false

export default new Vuex.Store({
  modules: {
    user,
    department,
    setting,
    personal,
    xiaoben,
    analysis,
    teaching,
    batchDownload
  },
  strict: debug// 严格模式，是否能在mutation外修改state值，true → 不能修改，false → 可以修改
})



// WEBPACK FOOTER //
// ./src/store/index.js